import { defineMessages } from 'react-intl';

export default defineMessages({
    requiredNotification: {
        id: 'customer.pa.wizard.step.policydetails.requiredNotification',
        defaultMessage: 'Throughout the quote workflow, fields marked with a red asterisks ({asteriskIcon}) are the minimum required fields to obtain an indicative quote. Please note that not all pages or sections will necessarily contain these required fields.'
    },
});
